import React from "react";
import { ExternalLink, ChevronRight } from "lucide-react";

const DynamicCards = ({ data, title }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return null;
  }

  const getFieldName = (key) => {
    // Convert snake_case to Title Case
    return key
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const formatValue = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'boolean') {
      return value ? '✓' : '✗';
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return String(value);
  };

  const getCardTitle = (item) => {
    // Try to find a suitable title field
    const titleFields = ['name', 'title', 'subject', 'label', 'description'];
    for (const field of titleFields) {
      if (item[field]) return item[field];
    }
    return Object.values(item)[0] || 'Item';
  };

  return (
    <div>
      {title && (
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-gray-900">{title}</h3>
          <span className="px-2 py-1 bg-emerald-100 text-emerald-700 rounded-full text-xs font-medium">
            {data.length} résultat(s)
          </span>
        </div>
      )}
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {data.map((item, index) => {
          const cardTitle = getCardTitle(item);
          const entries = Object.entries(item).filter(([key]) => key !== 'id');
          
          return (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-5 shadow-sm hover:shadow-lg transition-all group"
            >
              {/* Card Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-gray-900 truncate text-lg">
                    {cardTitle}
                  </h4>
                </div>
                <button className="p-1.5 text-gray-400 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg transition-colors opacity-0 group-hover:opacity-100">
                  <ExternalLink size={16} />
                </button>
              </div>

              {/* Card Content */}
              <div className="space-y-3">
                {entries.slice(0, 5).map(([key, value]) => (
                  <div key={key} className="flex items-start space-x-2">
                    <div className="flex-shrink-0 w-1.5 h-1.5 bg-emerald-500 rounded-full mt-2"></div>
                    <div className="flex-1 min-w-0">
                      <span className="text-xs font-medium text-gray-500 uppercase tracking-wider block">
                        {getFieldName(key)}
                      </span>
                      <p className="text-sm text-gray-900 truncate">
                        {formatValue(value)}
                      </p>
                    </div>
                  </div>
                ))}
                
                {entries.length > 5 && (
                  <button className="flex items-center space-x-1 text-sm text-emerald-600 hover:text-emerald-700 transition-colors mt-2">
                    <span>Voir plus</span>
                    <ChevronRight size={14} />
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DynamicCards;
